import * as React from "react";
import { useHistory } from "react-router-dom";
import CookiesModel from "../../../CookiesModel";
import { BDTRoutes } from "../../../helpers/applicationConstants";
import { PanelAppContext } from "../../../PanelAppProvider";
import { usePanelProjectContext } from "../../PanelProjectProvider";
import useAsset from "../../Project/Viewer/hooks/useAsset";

interface IPanelAppProvider {
    cookies: CookiesModel | undefined;
    setCookies: React.Dispatch<React.SetStateAction<CookiesModel | undefined>>;
}

const Redirect = () => {
    const history = useHistory();
    const { isViewerReady, setView } = usePanelProjectContext();
    const { cookies, setCookies } = React.useContext<IPanelAppProvider>(PanelAppContext);

    const { fetchingAssetInformationById } = useAsset();

    React.useEffect(() => {
        if (cookies) {
            switch (isViewerReady) {
                case false:
                    history.push(BDTRoutes.Project.Viewer.Viewer.Builder(`${cookies.projectId}`));
                    break;
                case true:
                    switch (cookies.viewPanel) {
                        case "view":
                            fetchingAssetInformationById(
                                `${cookies.projectId}`,
                                `${cookies.assetId}`,
                                true,
                                undefined
                            );
                            setView(`${cookies.viewButton}`);
                            break;
                        default:
                            break;
                    }

                    document.cookie = `projectId=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                    document.cookie = `assetId=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                    document.cookie = `viewPanel=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                    document.cookie = `viewButton=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;

                    setCookies(undefined);

                    break;
                default:
                    break;
            }
        }
    }, [isViewerReady, cookies]);

    return <></>;
};

export default Redirect;
